export const environment = {
  mode: import.meta.env.MODE,
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,
  appEnv: import.meta.env.VITE_APP_ENV,
  graphqlUrl: import.meta.env.VITE_GRAPHQL_URI,
  downloadUrl: import.meta.env.VITE_DOWNLOAD_URI, 
  activeDirectoryB2CAuthorizeUrl: import.meta.env.VITE_ACTIVE_DIRECTORY_B2C_AUTHORIZE_URL, 
  activeDirectoryB2CPasswordResetUrl: import.meta.env.VITE_ACTIVE_DIRECTORY_B2C_PASSWORD_RESET_URL,
  activeDirectoryApiId: import.meta.env.VITE_ACTIVE_DIRECTORY_API_ID,
  activeDirectoryRedirectUri: import.meta.env.VITE_ACTIVE_DIRECTORY_REDIRECT_URI,
  activeDirectoryAuthorizeUrl: import.meta.env.VITE_ACTIVE_DIRECTORY_AUTHORIZE_URL,
  teamleaderAdminRedirectUri: import.meta.env.VITE_TEAMLEADER_ADMIN_REDIRECT_URI,
  teamleaderUserRedirectUri: import.meta.env.VITE_TEAMLEADER_USER_REDIRECT_URI,
  microsoftOfficeAuthorizeUrl: import.meta.env.VITE_MICROSOFT_OFFICE_AUTHORIZE_URL,
  microsoftOffice365AdminConsentUrl: import.meta.env.VITE_MICROSOFT_OFFICE_365_ADMIN_CONSENT_URL,
  microsoftOfficeRedirectUri: import.meta.env.VITE_MICROSOFT_OFFICE_REDIRECT_URI,
  microsoftOffice365AdminConsentRedirectUri: import.meta.env.VITE_MICROSOFT_OFFICE_365_ADMIN_CONSENT_REDIRECT_URI,
  swaggerUrl: import.meta.env.VITE_SWAGGER_URL,
  appInsightsKey: import.meta.env.VITE_APPINSIGHTS_KEY,
  hotjarSiteId: import.meta.env.VITE_HOTJAR_SITE_ID,
  hotjarVersion: import.meta.env.VITE_HOTJAR_VERSION,
};